import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookOpen, Sunrise, Sunset, Wind, ShieldCheck } from 'lucide-react';
const deliverables = [{
  icon: BookOpen,
  title: 'El Manual Maestro',
  desc: 'En PDF de lectura rápida (menos de 20 minutos).'
}, {
  icon: Sunrise,
  title: 'El Protocolo AM',
  desc: 'Los 3 pasos exactos para anular el cortisol al despertar.'
}, {
  icon: Sunset,
  title: 'El Protocolo PM',
  desc: "La técnica de 'descarga de archivos' para apagar el ruido mental."
}, {
  icon: Wind,
  title: 'Guiones de respiración',
  desc: 'Dirigida específicamente para estados de emergencia.'
}, {
  icon: ShieldCheck,
  title: 'Checklist de entorno',
  desc: 'Para blindar tu habitación contra el estrés.'
}];
export function WhatYouGet() {
  return <section className="py-24 px-6 bg-white/40 border-y border-[#E5E0D8]" data-id="element-141">
      <div className="max-w-4xl mx-auto" data-id="element-142">
        <FadeIn data-id="element-143">
          <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center text-[#1C1917]" data-id="element-144">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="grid gap-4" data-id="element-145">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-146">
              <div className="flex items-start md:items-center gap-6 p-6 bg-white rounded-sm border border-[#E5E0D8] hover:border-[#C26D5C]/30 transition-colors" data-id="element-147">
                <div className="bg-[#FAF7F2] p-3 rounded-sm shrink-0" data-id="element-148">
                  <item.icon className="w-6 h-6 text-[#C26D5C]" strokeWidth={1.5} data-id="element-149" />
                </div>
                <div data-id="element-150">
                  <h4 className="font-medium text-[#1C1917] text-lg mb-1" data-id="element-151">
                    {item.title}
                  </h4>
                  <p className="text-[#4A4541]" data-id="element-152">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}